import { HttpClient } from '@/components/shared/http-client'
// eslint-disable-next-line no-unused-vars
import { POLICY_DETAIL, POLICY_DETAIL_EXTERNAL } from '@/router/route-names'

async function getPolicies(accountCode) {
  const url = `/api/accounts/${accountCode}/policies`
  const response = await HttpClient.get(url)
  return response
}

async function uploadPolicy(accountCode, policy) {
  const url = `/api/accounts/${accountCode}/policies`

  const response = await HttpClient.post(url, policy)
  const savedPolicy = response.data
  if (policy.file !== undefined) {
    await uploadPolicyFile(url, savedPolicy.id, policy)
  }
}
async function uploadPolicyFile(url, policyId, policy) {
  const fileUploadUrl = `${url}/${policyId}`
  const form = new FormData()
  form.append('file', policy.file)
  await HttpClient.post(fileUploadUrl, form)
}

async function removePolicy(accountCode, policy) {
  const url = `/api/accounts/${accountCode}/policies/delete`
  await HttpClient.post(url, policy)
}

function generatePolicyKey(policy) {
  return `${policy.policyNumber}_${policy.effectiveDate}`
}

function goToPolicyDetailPage(router, accountCode, policy) {
  if (policy.id) {
    router.push({
      name: POLICY_DETAIL,
      params: {
        accountId: accountCode,
        policyId: policy.id,
      },
    })
  } else {
    router.push({
      name: POLICY_DETAIL_EXTERNAL,
      params: {
        accountId: accountCode,
        policyKey: generatePolicyKey(policy),
      },
    })
  }
}

function buildPolicyDetailRoute(accountCode, policy) {
  if (policy.id) {
    return `/${accountCode}/policy-admin/policy/${policy.id}`
  } else {
    return `/${accountCode}/policy-admin/external/${generatePolicyKey(policy)}`
  }
}

function decodePolicyKey(policyKey) {
  const [policyNumber, effectiveDate] = policyKey.split('_')
  return {
    policyNumber: decodeURIComponent(policyNumber),
    effectiveDate: decodeURIComponent(effectiveDate),
  }
}

export {
  getPolicies,
  uploadPolicy,
  uploadPolicyFile,
  removePolicy,
  generatePolicyKey,
  decodePolicyKey,
  goToPolicyDetailPage,
  buildPolicyDetailRoute,
}
